module.exports = __webpack_public_path__ + "static/media/grid-view.387a34cd.svg";